import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/success.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3258252a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Tes Sudah Selesai")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "success",
    src: _imports_0
  })
], -1))
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = { class: "message" }
const _hoisted_7 = { class: "col-sm-12 d-flex justify-content-between" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "content w-full bg-white" }
const _hoisted_10 = { class: "t-test-live__content" }
const _hoisted_11 = {
  key: 0,
  class: "animate-pulse"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-24 lg:h-56 w-full bg-gray-200 rounded-md mb-3 lg:mb-5" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-24 lg:h-56 w-full bg-gray-200 rounded-md mb-3 lg:mb-5" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-24 lg:h-56 w-full bg-gray-200 rounded-md" }, null, -1))
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "t-test-live__content__test d-flex flex-column"
}
const _hoisted_17 = ["id"]
const _hoisted_18 = { class: "t-test-live__content__test__question" }
const _hoisted_19 = { class: "text-xl text-center font-semibold" }
const _hoisted_20 = { class: "t-test-live__content__test__answer" }
const _hoisted_21 = { class: "d-flex flex-row justify-content-center" }
const _hoisted_22 = { class: "d-flex flex-column" }
const _hoisted_23 = { class: "d-flex flex-row" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "d-flex flex-row justify-content-between hide-desktop-flex" }
const _hoisted_26 = { class: "t-test-live__content__test__action" }
const _hoisted_27 = { class: "d-flex justify-content-between" }
const _hoisted_28 = { class: "t-test-live__content__test__action-progress d-flex flex-column" }
const _hoisted_29 = { class: "text-primary-gc text-xl font-semibold" }
const _hoisted_30 = { class: "text-dark-gray-gc text-sm font-semibold" }
const _hoisted_31 = { class: "t-test-live__content__test__action-button d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BModal = _resolveComponent("BModal")!
  const _component_GcHeader = _resolveComponent("GcHeader")!
  const _component_BProgress = _resolveComponent("BProgress")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_BButton = _resolveComponent("BButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BModal, {
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModal) = $event)),
      id: "success-modal",
      "hide-header": "",
      "hide-footer": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, " Tes " + _toDisplayString(_ctx.testDetail.name) + " sudah berhasil kamu selesaikan, Segera selesaikan semua tes yang tersedia ", 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn regular w-100 btn-warning",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, " OK ")
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_GcHeader, { "profile-data": _ctx.profileData }, null, 8, ["profile-data"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_15))
        : _createCommentVNode("", true),
      (!_ctx.isLoading && _ctx.testQuestion)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testQuestion, (question, questionIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                id: `question-box-${questionIndex}`,
                key: questionIndex,
                class: _normalizeClass(['t-test-live__content__test__wrapper'])
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", _hoisted_19, _toDisplayString(question.question), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  (question.answer_type)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answer_type.answers, (answer, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "col"
                            }, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("hr", {
                                    class: _normalizeClass(["separator", { 'separator--transparent': index == 0 }])
                                  }, null, 2),
                                  (_openBlock(), _createElementBlock("div", {
                                    key: answer.id,
                                    class: _normalizeClass([
                          'circle',
                          _ctx.isActive({
                            question,
                            answer,
                          })
                            ? 'active'
                            : '',
                        ]),
                                    onClick: ($event: any) => (
                          _ctx.setAnswer({
                            question,
                            answer,
                            questionIndex,
                          })
                        )
                                  }, null, 10, _hoisted_24)),
                                  _createElementVNode("hr", {
                                    class: _normalizeClass([{
                          'separator--transparent':
                            index == question.answer_type.answers.length - 1,
                        }, "separator"])
                                  }, null, 2)
                                ]),
                                (
                        index === 0 ||
                        index === question.answer_type.answers.length - 1
                      )
                                  ? (_openBlock(), _createElementBlock("p", {
                                      key: 0,
                                      class: _normalizeClass(`${
                        index === 0
                          ? 'text-error-text-gc pl-14'
                          : 'text-primary-gc pr-20'
                      } text-sm font-semibold mt-4 hide-mobile`),
                                      style: _normalizeStyle({ textAlign: index === 0 ? 'left' : 'right' })
                                    }, _toDisplayString(answer.answer), 7))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answer_type.answers, (answer, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              (
                    index === 0 ||
                    index === question.answer_type.answers.length - 1
                  )
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: index,
                                    class: _normalizeClass(`${
                    index === 0 ? 'text-error-text-gc' : 'text-primary-gc'
                  } text-sm font-semibold mt-4`),
                                    style: _normalizeStyle({ textAlign: index === 0 ? 'left' : 'right' })
                                  }, _toDisplayString(answer.answer), 7))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_17))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.testDetail.name), 1),
          _createVNode(_component_BProgress, {
            class: "my-2",
            max: _ctx.testQuestion.length,
            value: Object.keys(_ctx.answerUser).length,
            variant: "warning"
          }, null, 8, ["max", "value"]),
          _createElementVNode("p", _hoisted_30, _toDisplayString(Object.keys(_ctx.answerUser).length) + " / " + _toDisplayString(_ctx.testQuestion.length) + " Pertanyaan Diisi ", 1)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_BButton, {
            disabled: _ctx.isDisabled,
            variant: _ctx.isDisabled ? 'secondary' : 'warning',
            class: _normalizeClass(`text-center text-sm
            font-semibold
            py-2
            px-8
            pointer-events-auto
            ${_ctx.isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`),
            onClick: _ctx.startTest
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Lanjutkan "),
              _createVNode(_component_FontAwesomeIcon, {
                class: "ml-2",
                icon: "chevron-right"
              })
            ]),
            _: 1
          }, 8, ["disabled", "variant", "class", "onClick"])
        ])
      ])
    ])
  ], 64))
}